import { useFirestore, useUser } from "reactfire";
import { addDoc, collection } from "firebase/firestore";
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Textarea, useDisclosure } from "@nextui-org/react";

export const NewGenerator = () => {
    const firestore = useFirestore();
    const user = useUser();

    const saveGenerator = (event: any) => {
        event?.preventDefault();
        const extractorCollection = collection(firestore, 'generators');

        const formData = new FormData(event.target);

        const data = {
            name: formData.get('name'),
            description: formData.get('description'),
            createdByName: user?.data?.displayName,
            blocks : [], 
            testFile: null, 
            createdBy: user?.data?.uid,
            lastUpdated: new Date().toISOString()
        }

        return addDoc(extractorCollection, data);
    }

    const { isOpen, onOpen, onOpenChange } = useDisclosure();
    return (
        <>
            <Button color="primary" onPress={onOpen}>Create Generator</Button>
            <Modal
                isOpen={isOpen}
                onOpenChange={onOpenChange}
                placement="top-center"
            >
                <form onSubmit={saveGenerator}>

                    <ModalContent>
                        {(onClose) => (
                            <>
                                <ModalHeader className="flex flex-col gap-1">New Generator</ModalHeader>
                                <ModalBody>
                                    <Input
                                        autoFocus
                                        isRequired
                                        label="Name"
                                        name="name"
                                        placeholder="Provide a Name"
                                        variant="bordered"
                                    />
                                    <Textarea
                                        name="description"
                                        label="Description"
                                        placeholder="Describe your Generator"
                                        type="textarea"
                                        variant="bordered"
                                    />
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" variant="flat" onPress={onClose}>
                                        Close
                                    </Button>
                                    <Button color="primary" onClick={onClose} type="submit">
                                        Save
                                    </Button>
                                </ModalFooter>
                            </>
                        )}
                    </ModalContent>
                </form>
            </Modal>
        </>
    )
}